import { PatientId } from "../../../shared/schema/schema";
import MedicalDiagnosisCodeTable from "./MedicalDiagnosisCodeTable";

type Props = {
  /** Shows the codes without add / edit / delete. */
  isReadOnly?: boolean;
  patientId: PatientId;
  /** After each successful add, edit or delete. */
  onChanged?: () => void;
  /** Whether an add / edit / delete dialog is open. */
  onFormOpenChange?: (isOpen: boolean) => void;
};

export default function PatientMedicalDiagnosisCodeSection(props: Props) {
  return (
    <MedicalDiagnosisCodeTable
      isReadOnly={props.isReadOnly}
      patientId={props.patientId}
      onChanged={props.onChanged}
      onFormOpenChange={props.onFormOpenChange}
    />
  );
}
